export const GET_ACTIONS_REQUEST = 'GET_ACTIONS_REQUEST';
export const GET_ACTIONS_SUCCESS = 'GET_ACTIONS_SUCCESS';
export const GET_ACTIONS_ERROR = 'GET_ACTIONS_ERROR';
export const ADD_ACTION_REQUEST = 'ADD_ACTION_REQUEST';
export const ADD_ACTION_SUCCESS = 'ADD_ACTION_SUCCESS';
export const ADD_ACTION_ERROR = 'ADD_ACTION_ERROR';
export const UPDATE_ACTION_REQUEST = 'UPDATE_ACTION_REQUEST';
export const UPDATE_ACTION_SUCCESS = 'UPDATE_ACTION_SUCCESS';
export const UPDATE_ACTION_ERROR = 'UPDATE_ACTION_ERROR';
export const GET_ACTION_REQUEST = 'GET_ACTION_REQUEST';
export const GET_ACTION_SUCCESS = 'GET_ACTION_SUCCESS';
export const GET_ACTION_ERROR = 'GET_ACTION_ERROR';
export const GET_ACTION_INFO_REQUEST = 'GET_ACTION_INFO_REQUEST';
export const GET_ACTION_INFO_SUCCESS = 'GET_ACTION_INFO_SUCCESS';
export const GET_ACTION_INFO_ERROR = 'GET_ACTION_INFO_ERROR';
export const DELETE_ACTION_REQUEST = 'DELETE_ACTION_REQUEST';
export const DELETE_ACTION_SUCCESS = 'DELETE_ACTION_SUCCESS';
export const DELETE_ACTION_ERROR = 'DELETE_ACTION_ERROR';
export const DUPLICATE_ACTION_REQUEST = 'DUPLICATE_ACTION_REQUEST';
export const DUPLICATE_ACTION_SUCCESS = 'DUPLICATE_ACTION_SUCCESS';
export const DUPLICATE_ACTION_ERROR = 'DUPLICATE_ACTION_ERROR';
export const EMPTY_ACTION_INFO = 'EMPTY_ACTION_INFO';
export const MERGE_ACTIONS = 'MERGE_ACTIONS';
